import { SectionName } from "@/entities/dossier-settings";
import { RoleGate } from "@/features/auth";
import { useSectionsContext } from "@/features/dossier-management";
import { ErrorDisplay, Skeleton } from "@/shared/components";
import { PropsWithChildren } from "react";
import { sectionConfigMap } from "../constants";

type SectionGateProps = {
    section: SectionName;
};

export function SectionGate({ section, children }: PropsWithChildren<SectionGateProps>) {
    const { isPending, error, isSectionEnabled } = useSectionsContext();

    if (isPending)
        return (
            <article className={"border-default rounded-m flex flex-col gap-3 overflow-clip border p-4 pb-3"}>
                <Skeleton className="h-10 w-1/3" />
                <div className="col-start-2">
                    <Skeleton className="h-10 w-full" />
                </div>
            </article>
        );

    if (error) {
        return (
            <ErrorDisplay
                error={error}
                variant="section"
                title="Fout bij het laden van het dossier"
                onRetry={() => window.location.reload()}
            />
        );
    }

    return <RoleGate roles={sectionConfigMap[section].roles}>{isSectionEnabled(section) && children}</RoleGate>;
}
